// extracted by mini-css-extract-plugin
export default {"subscribePrivacyTermsandConditions":"SLTX2zjjT0F3_8cE0wA0","disclosureLink":"p03njf9KsHwj_MfC54su"};